module.exports = __WEBPACK_EXTERNAL_MODULE__bentley_bentleyjs_core__;